export default __webpack_public_path__ + "static/media/labelsitter-element.16baa0a4.jpg";